/* Ervaringenpagina: alleen meetpunten.

   De pagina werkt zonder JavaScript: het cijfer, de uitgelichte reviews, de
   keurmerken en de vragen staan server-side in de HTML. Alleen de
   TrustedShops-widget laadt zichzelf, en die heeft zijn eigen script. */
(function () {
  'use strict';

  function duw(gebeurtenis, gegevens) {
    window.dataLayer = window.dataLayer || [];
    var lading = { event: gebeurtenis, pageType: 'Page' };
    Object.keys(gegevens || {}).forEach(function (k) {
      lading[k] = gegevens[k];
    });
    window.dataLayer.push(lading);
  }

  document.addEventListener('click', function (e) {
    var bron = e.target.closest && e.target.closest('[data-solza-ervaringen-bron]');
    if (bron) {
      duw('solza_ervaringen_bron_klik', {
        ervaringen: { bron: bron.dataset.solzaErvaringenBron || '' }
      });
      return;
    }

    var kaart = e.target.closest && e.target.closest('[data-solza-kaartknop]');
    if (kaart) {
      duw('solza_ervaringen_kaart_klik', {
        ervaringen: { kaart: kaart.dataset.solzaKaartknop || '' }
      });
    }
  });
})();
